import { Component, OnDestroy, OnInit, model } from '@angular/core'

import { Editor, Toolbar } from 'ngx-editor'

@Component({
    selector: 'text-editor',
    template: `
        <div class="NgxEditor__Wrapper">
            <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
            <ngx-editor
                [editor]="editor"
                outputFormat="html"
                [ngModel]="editorTextContent()"
                (ngModelChange)="editorContentChanged($event)"
                [style]="{ 'min-height': '250px', display: 'block', overflow: 'auto' }"
            ></ngx-editor>
        </div>
    `
})
export class TextEditorComponent implements OnInit, OnDestroy {
    editor: Editor
    toolbar: Toolbar = [
        ['bold', 'italic'],
        ['underline', 'strike'],
        ['code', 'blockquote'],
        ['ordered_list', 'bullet_list'],
        [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
        ['link', 'image'],
        ['text_color', 'background_color'],
        ['align_left', 'align_center', 'align_right', 'align_justify'],
        ['horizontal_rule', 'format_clear', 'indent', 'outdent'],
        ['superscript', 'subscript'],
        ['undo', 'redo']
    ]
    editorTextContent = model<string>()

    ngOnInit(): void {
        this.editor = new Editor()
    }

    editorContentChanged(htmlText: string) {
        this.editorTextContent.set(htmlText)
    }

    ngOnDestroy(): void {
        this.editor.destroy()
    }
}
